module.exports = __webpack_public_path__ + "img/no_sequences.248d31f7.jpg";